<template lang="html">
  <pl-dialog padding="0" @close="$emit('close')">
    <div class="ph2" style="background-color: #72ccd7">
      <div class="flex items-center pa4">
        <img
          src="/static/course/universe_icon.svg"
          alt=""
          style="width: 50px"
        />
        <span class="pl-title col-xs" style="color: #fff"
          >Share this RoundTable prompt with the Parlay Community!
        </span>
      </div>
    </div>
    <template>
      <transition name="slide-from-right" mode="out-in">
        <div
          class="flex justify-center ma4"
          v-if="share_tab === 'share_card'"
          key="share_card"
        >
          <div class="mh3 mv1">
            <premade-card
              style="width: 223px"
              :premade="premade"
              :cancelClick="true"
            />
          </div>
          <div>
            <pl-input v-model="premade.title" label="Title" />
            <span class="underline clickable" @click="share_tab = 'pick_photo'"
              >Choose Photo</span
            >
            <br /><br />
            <pl-menu :menuSize="5">
              <pl-button
                slot="menu_trigger"
                style="
                  border: 2px solid #e1e8ee;
                  border-radius: 5px;
                  min-width: 210px;
                "
              >
                <div class="flex">
                  <span class="col-xs-10" v-if="premade.subject">
                    {{ premade.subject | truncate(23) }}
                  </span>
                  <span v-else class="col-xs-10">Subject Area</span>
                  <span class="col-xs-2">
                    <i class="fa fa-caret-down"></i>
                  </span>
                </div>
              </pl-button>
              <ul menu-content>
                <li
                  v-for="subject in subject_list"
                  @click="premade.subject = subject.name"
                >
                  {{ subject.name }}
                </li>
              </ul>
            </pl-menu>
            <br /><br />
            <pl-button class="pl-ruby" @click.native="submitPremade"
              >SHARE PROMPT</pl-button
            >
          </div>
        </div>

        <div class="mv2 mh4" v-if="share_tab === 'pick_photo'" key="pick_photo">
          <div class="row items-center justify-center">
            <div class="col-xs-1">
              <i
                v-if="thumbnail_page !== 0"
                class="fas fa-angle-left fa-3x scrolling-arrows"
                @click="thumbnail_page = thumbnail_page - 1"
              />
            </div>
            <div class="row middle-xs center-xs col-xs">
              <div v-for="thumbnail in thumbnail_list[thumbnail_page]">
                <div
                  class="card-container pa2 ma1"
                  @click="selectNewThumbnail(thumbnail)"
                >
                  <img :src="thumbnail" alt="" />
                </div>
              </div>
            </div>
            <div class="col-xs-1">
              <i
                v-if="thumbnail_page < thumbnail_list.length - 1"
                class="fas fa-angle-right fa-3x scrolling-arrows"
                @click="thumbnail_page = thumbnail_page + 1"
              />
            </div>
          </div>
        </div>

        <div
          class="row center-xs ma4"
          v-if="share_tab === 'success'"
          key="success"
        >
          <div class="mh3">
            <premade-card
              style="width: 223px"
              :premade="premade"
              :cancelClick="true"
            />
          </div>
          <div class="ml1 col-xs-5" style="padding: 0">
            <p class="b pl-subheading">All Done!</p>
            <div class="row center-xs middle-xs">
              <pl-button
                :data-clipboard-text="sharing_url"
                class="pl-white copy-button-share-link"
              >
                <span>COPY LINK</span>
                <transition name="appear-fade">
                  <i
                    v-if="copy_success"
                    class="fas fa-check ml2 pl-color-ruby"
                  ></i>
                </transition>
              </pl-button>
              <img
                src="/static/twitter_button.svg"
                @click="shareOnTW"
                class="social-icons mr2"
              />
              <img
                src="/static/facebook_button.svg"
                @click="shareOnFB"
                class="social-icons"
              />
            </div>
            <div>
              <pl-button class="pl-ruby" @click.native="goToPremadePage"
                >GO TO PROMPT</pl-button
              >
            </div>
            <br />
            <p class="pl-caption">
              Our team will also review your prompt before adding it to our
              searchable collections in The Universe!
            </p>
            <p class="pl-caption">Questions? AnnaLisa@parlayideas.com</p>
          </div>
        </div>
      </transition>
    </template>
  </pl-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { makeRequest } from 'utils/requestLogger';
  import { premadeThumbnailList } from './premadeThumbnailList';
  import { EventBus } from 'utils/event-bus';
  import config from 'services/apiConfigs';
  import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import premadeCard from 'components/universe/premadeCard';
  import Clipboard from 'clipboard';

  const clipboard = new Clipboard('.copy-button-share-link');

  export default {
    data() {
      return {
        copy_success: false,
        share_tab: 'share_card',
        thumbnail_page: 0,
        subject_list: [],
        premade: {
          title: '',
          author_name: '',
          author_avatar: '',
          thumbnail_url: '1.webp',
          prompt: '',
          author_id: '',
          subject: '',
        },
      };
    },
    components: {
      premadeCard,
      premadeThumbnailList,
      roundtableService,
      Clipboard,
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'getProfile']),
      thumbnail_list() {
        return premadeThumbnailList;
      },
      sharing_url() {
        return `${config.universeURL}/roundtables/${this.getCurrentRT.meta.premade_id}`;
      },
    },
    created() {
      clipboard.on('success', () => {
        this.copy_success = true;
      });

      // Facebook Init
      /*eslint-disable */
      // window.fbAsyncInit = () => {
      //   FB.init({
      //     appId: '1550372328564661',
      //     autoLogAppEvents: true,
      //     xfbml: true,
      //     version: 'v2.12',
      //   });
      // };
      // (function (d, s, id) {
      //   var js,
      //     fjs = d.getElementsByTagName(s)[0];
      //   if (d.getElementById(id)) {
      //     return;
      //   }
      //   js = d.createElement(s);
      //   js.id = id;
      //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
      //   fjs.parentNode.insertBefore(js, fjs);
      // })(document, 'script', 'facebook-jssdk');
      /*eslint-enable */

      this.getCurrentRT.meta.premade_id
        ? (this.share_tab = 'success')
        : makeRequest('get', `/api/subjects`)
            .then((res) => {
              this.subject_list = res.data.filter((e) => {
                return e.name !== 'Parlay Specials';
              });
            })
            .catch(console.log);
      this.premade = {
        title: this.getCurrentRT.title,
        author_name: this.getProfile.name,
        author_avatar: this.getProfile.avatar_url,
        thumbnail_url: '1.webp',
        prompt: this.getCurrentRT.prompt,
        author_id: this.getProfile.id,
        subject: '',
      };
    },
    methods: {
      selectNewThumbnail(thumbnail) {
        const new_url = thumbnail.substr(thumbnail.lastIndexOf('/') + 1);
        this.premade.thumbnail_url = new_url;
        this.share_tab = 'share_card';
      },
      submitPremade() {
        roundtableService
          .createPremade(this.premade)
          .then((res) => {
            const payload = {
              id: this.getCurrentRT.id,
              meta: { premade_id: res.data.id },
            };
            this.$store.dispatch('savingRTDetails', payload);
            this.share_tab = 'success';
          })
          .catch((e) => {
            console.error(e);
            EventBus.$emit(
              'toast-msg',
              'Something went wrong, please refresh!'
            );
          });
      },
      formatParam(param) {
        return param
          .replace(/%/g, '%25')
          .replace(/ /g, '%20')
          .replace(/\$/g, '%24')
          .replace(/#/g, '%23');
      },
      goToPremadePage() {
        window.open(
          `${config.universeURL}/roundtables/${this.getCurrentRT.meta.premade_id}`
        );
      },
      shareOnTW() {
        const rtTitle = this.getCurrentRT.title;
        const url = this.formatParam(this.sharing_url);
        const text = this.formatParam(
          `Check out my new RoundTable discussion "${rtTitle}" on @parlayideas`
        );
        window.open(
          `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
          '',
          'scrollbars=yes,width=650,height=280'
        );
      },
      shareOnFB() {
        /*eslint-disable */
        // FB.ui(
        //   {
        //     method: 'share',
        //     href: this.formatParam(this.sharing_url),
        //   },
        //   function (response) {}
        // );
        /*eslint-enable */
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .social-icons
    height: 35px !important
    padding-left: 0
    &&:hover
      cursor: pointer
      cursor: hand

  .slide-from-right-enter-active, .slide-from-right-leave-active
    transition: all 0.7s ease
  .slide-from-right-enter, .slide-from-right-leave-to
    transform: translateX(80px)
    opacity: 0

  .card-container
    border-radius: 2px
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)
    transition: box-shadow .2s
    &:hover
      cursor: pointer
      box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)
      transition: box-shadow .2s

  .scrolling-arrows
    color: pl-slate
    &:hover
      cursor: pointer
      color: pl-primary
      -ms-transform: scale(1.3,1.8) /* IE 9 */
      -webkit-transform: scale(1.3,1.8) /* Safari */
      transform: scale(1.3,1.8) /* Standard syntax */
      transition: transform .1s ease-out 0s,
      -webkit-transform .1s ease-out 0s,
      -moz-transform .1s ease-out 0s,
      -o-transform .1s ease-out 0s
</style>



// WEBPACK FOOTER //
// shareToUniverseModal.vue?22be95b7